import { combineReducers } from '@reduxjs/toolkit'

import { userSliceName, userReducer } from "./profile";

export const rootReducer = combineReducers({
  [userSliceName]: userReducer
});
